module.exports = __webpack_public_path__ + "assets/form.02998845.svg";